import React from 'react';
import PropTypes from 'prop-types';
import { ListRow } from './ListRow'
import { Card } from './Card';
import { CardHeader } from './CardHeader';
import { CardBody } from './CardBody';

export const List = ({ title, rows, className, children, ...rest }) => {
  
  return (
    <Card className={className}>
      <CardHeader>{title}</CardHeader>
      <CardBody>
        { rows && rows.map((row, i) => (
          <ListRow key={i} icon={row?.icon} iconColor={row?.iconColor}>
          {row?.content}
          </ListRow>
        ))}
      </CardBody>
    </Card>
  )
};

List.propTypes = {
  title: PropTypes.string,
  rows: PropTypes.array,
};


List.defaultProps = {
  rows: [],
};

/*
EXAMPLE USAGE

const rows = [
    {
      icon: "bell",
      iconColor: 'danger',
      content: (
        <>
          <Typography>Ostohinnat laskematta</Typography>
          <Typography bold>Tilaukseen abc takki</Typography>
        </>
      ),
    },
    {
      icon: "bell",
      iconColor: 'danger',
      content: (
        <>
          <Typography>Ostohinnat laskematta</Typography>
          <Typography bold>Tilaukseen abc takki</Typography>
        </>
      ),
    },
    {
      icon: "bell",
      iconColor: 'danger',
      content: (
        <>
          <Typography>Ostohinnat laskematta</Typography>
          <Typography bold>Tilaukseen abc takki</Typography>
        </>
      ),
    }
  ]
  
<List 
  title="Vaadittavat toimenpiteet"
  rows={rows}
/>
*/
